module.exports = __webpack_public_path__ + "static/img/cadrage_bg_1.5116fbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cadrage_bg_1.jpg
// module id = i7yk
// module chunks = 1